<template>
	<div class="l-text-button" :class="typeClass" v-bind="$attrs" @click="handleClick">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: "l-text-button",
	props: {
		type: {
			type: String,
			default: "primary",
		},

		disabled: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		typeClass() {
			const { type, disabled } = this.$props;
			if (disabled) {
				return ["text-button-disabled"];
			}
			switch (type) {
				case "danger":
					return ["text-button-danger"];
				default:
					return ["text-button-primary"];
			}
		},
	},

	methods: {
		handleClick() {
			if (this.$props.disabled) return;
			this.$emit("click");
		},
	},
};
</script>

<style lang="scss" scoped>
.l-text-button {
	display: inline-block;
	vertical-align: middle;
	cursor: pointer;
}

.text-button-primary {
	color: $primary-color;
}

.text-button-danger {
	color: $danger-color;
}

.text-button-disabled {
	color: $disabled-color;
	cursor: default;
}
</style>
